// 处理后端来的数据
import store from '@/store'
import _ from 'lodash'

export const needShowMultiComplexFields = ['p-151386995', 'p-149422948'] // 一些schema返回的非必填的，但是不填又报错的MultiComplex表单域，这种先展示渲染为Complex使其可以填写一组数据

const nendTransformMultiFields = ['images','item_images', 'threeToFourImages', 'newWirelessDesc', 'verticalImage', 'useGroupImages'];

const undefinedHandle = (value, defaultVal = "") => {
  return value === undefined ? defaultVal : value
}
export function _formatValue(data, value, displayName) {
  let defaultValue = '', valueDisplayName = '';
  if (value instanceof Array) {
    defaultValue = value.length ? JSON.stringify(value) : null
    valueDisplayName = displayName ? JSON.stringify(displayName) : null
  } else {
    defaultValue = value
    valueDisplayName = displayName ? JSON.stringify(displayName) : null
  }
  data.defaultValue = defaultValue
  data.valueDisplayName = valueDisplayName
  if(Number(defaultValue) < 0 && valueDisplayName) {
    data.extendValue =  {
      [defaultValue]: { inputValue: valueDisplayName}
    }
  }
  return data
}
// 将_formatValue转换的value反转回来
export function reversValue(data, type) {
  let value = '';
  if(type == 'MULTICHECK') {
    let defaultValue = []
    try {
      defaultValue = data.defaultValue ? JSON.parse(data.defaultValue) : []
    } catch (error) {
      console.log(error)
    }
    if (defaultValue instanceof Array) {
      value = defaultValue
    } else if (typeof(data.defaultValue) === 'string') {
      value = [String(defaultValue)]
    } else if (typeof(data.defaultValue) === 'number') {
      value = [Number(defaultValue)]
    } else {
      value = []
    }
    // 判断是否含有自定义的值（即负数）
    if(value.some(v => Number(v) < 0 && data.extendValue)) {
      value.forEach((v, i) => {
        if(v => Number(v) < 0) {
          value[i] = data.extendValue[v]?.inputValue || v
        }
      })
    }
  } else if(type == 'SINGLECHECK') {
    if(Number(data.defaultValue) < 0 && data.extendValue) {  // 自定义下拉选项填充值处理
      value = undefinedHandle(data.extendValue[data.defaultValue]?.inputValue)
    } else {
      value = undefinedHandle(data.defaultValue)
    }
  } else {
    value = undefinedHandle(data.defaultValue)
  }
  return value;
} 
const getAuctionVideosValue = (data) => {
  const valueList = (data?.children || []).map(children => {
    const childrenSVideoItem = children.children.find(child => child.name === 'videoId') || {};
    const { defaultValue, extendValue }  = childrenSVideoItem
    if (!defaultValue || !extendValue || !extendValue[defaultValue] || !extendValue[defaultValue].videoInfoJson) {
      return {};
    }
    const childrenSVideoItemVideoType = children.children.find(child => child.name === 'videoType') || {};
    const videoInfoJson = JSON.parse(extendValue[defaultValue].videoInfoJson || {});
    return {
      ...videoInfoJson,
      videoInfoJson,
      videoType: childrenSVideoItemVideoType.defaultValue || ''
    };
  });
  return valueList
}
// 将当前tbForm转为后端保存时需要的数据格式
export const form2data = (form, data) => {
  // console.log(form, '----form')
  // console.log(data, '----data')
  

  const dataKeys = Object.keys(data)
  let _data = {}

  dataKeys.forEach(dataKey => {
    // 根据原后端所需字段，去form中对应字段值填入_data
    if (dataKey === 'cid') {
      // 叶子类目id
      _data[dataKey] = form.categoryIds[form.categoryIds.length - 1]
    } else if (['skuList', 'specifications'].includes(dataKey)) {
      // 处理规格详情、处理规格信息
      // 这三个数据由Specification.vue组件的method_getData方法获取
      // 不在这里做格式化处理
      return ;
    } else if (['tbDeliveryTime'].includes(dataKey)) {
      // 只取value字段的字段集合处理
      // _data[dataKey] = form[dataKey]?.value
    } else {
      // 默认处理方式
      // form中有这个字段从form里拿，没有就沿用原data的
      _data[dataKey] = form.hasOwnProperty(dataKey) ? form[dataKey] : data[dataKey]
    }
  })


  return _data
}

// 手机端详情 --- 将表单富文本转为后端所需的xml
export const html2wapHtml = (html) => {
  // 采取dom的方式完成替换
  // <img src /> -> <img>src</img>
  // <其他>xxx</其他> -> <txt>xxx</txt>
  const div = document.createElement('div')
  div.innerHTML = `${(html || '').replace(/<\/?wapdesc>/g, '')}`
  const nodes = div.childNodes
  let wapHtml = ''

  function format(nodes) {
    nodes.forEach(node => {
      // console.log(node)

      if (node.childNodes && node.childNodes.length) {
        format(node.childNodes)
        return ;
      }

      if (node.nodeName === '#text') {
        if (!node.textContent.trim()) return;
        wapHtml += `<txt>${node.textContent}</txt>`
      } else if (node.nodeName === 'IMG') {
        wapHtml += `<img>${node.src}</img>`
      } else {
        if (!node.innerHTML.trim()) return;
        wapHtml +=  `<txt>${node.innerHTML}</txt>`
      }

    })
  }

  format(nodes)

  return `<wapdesc>${wapHtml}</wapdesc>`
}

// 手机端详情 --- 将后端传来的xml转为表单详情中的富文本
export const wapHtml2Html = (wapHtml) => {
  let html = wapHtml.replace(/<\/?wapdesc>/g, '')
  html = html.replace(/<\?xml[^>]+>/, '')
  html = html.replace('<txt>', '<p>')
  html = html.replace('</txt>', '</p>')
  html = html.replace(/<img[^>]*>([^>]+)<\/img>/g, '<img src="$1" />')
  return html
}

// 对一些数据进行默认赋值
export const dataDefaultValue = (data) => {
  let _data = {
    ...data
  }
  const defaultValueMap = {
    'stuffStatus': '5',
    'globalStockNav': '0',
    'subStock': '1',
  }
  for(const key in defaultValueMap) {
    if (_data[key] === 0) {
      _data[key] = String(_data[key])
    }
    if (_data.hasOwnProperty(key) && !_data[key]) {
      _data[key] = defaultValueMap[key]
    }
  }
  return _data
}


export const formatDataForm = (form, formSections) => {
  const { fieldDescriptorList = [] } = form || {};
  const _form = {};
  if(!fieldDescriptorList.length) return {}
  let tbIsNew = store.getters.tbIsNew
  const formatItem = (item, defaultData = null) => {
      // 特殊处理的字段 开始
      if (item.name === 'sku') {
        // 规格信息需要沿用之前组件，特殊处理
        return;
      }
      if (item.name === 'auctionVideos') {
        _form[item.name] = getAuctionVideosValue(defaultData);
        return;
      }
      if (nendTransformMultiFields.includes(item.name)) {
        _form[item.name] = defaultData && defaultData.children?.length ? defaultData.children.map(img => img.defaultValue) : [];
        return;
      }
      if (['wirelessDesc'].includes(item.name)) {
        if(defaultData?.children && defaultData.children.length){//新版编辑器返回的数据一定是个数组
          let imgChildren = defaultData.children.filter(c => c.name.indexOf('image_hot_area') != -1);
          let imgUrls = imgChildren.map(i => {
            let imageObj = (i.children || []).find(c => c.name === 'image');
            if(imageObj && imageObj.children){
              let urlObj = imageObj.children.find(im => im.name === 'url')
              return urlObj.defaultValue || ''
            }
            return ''
          });
          imgUrls = imgUrls.filter(i => i);
          _form[item.name] = imgUrls
        }else if(tbIsNew){// 新版编辑器没有图片的情况默认设置为空数组
          _form[item.name] = []
        }else{
          _form[item.name] = wapHtml2Html(defaultData?.defaultValue || '');
        }
        return;
      }
      const foodList = ['food_security.organic_food', 'food_security.is_green_food'];
      if(foodList.includes(item.name)) {
        _form[item.name] = defaultData?.defaultValue || '0'
        return;
      }
    
      if (item.children?.length) {
        item.children.map(ic => {
          formatItem(ic, defaultData?.children?.length ? defaultData.children.find(d => d && d.name === ic.name) : null)
        }).filter(Boolean)
        if (item.type === 'MULTICOMPLEX') {
          // 给多实例复合型表单赋值
          _form[item.name] = (defaultData?.children || []).map(cv => {
            let cvform = {}
            if(cv.children && cv.children.length) {
              cv.children.forEach((defaultData) => {
                if(defaultData){
                  cvform[defaultData.name] = reversValue(defaultData, item.type)
                }
              })
            } else {
              cvform[defaultData.name] = reversValue(defaultData, item.type)
            }
            return cvform
          })
        }
      } else {
        // 给表单赋值
        _form[item.name] = defaultData ? reversValue(defaultData, item.type) : undefined
      }
  }
  formSections.forEach(section => {
    section.children.forEach(item => {
      formatItem(item, fieldDescriptorList.find(v => item.name === v.name));
    })
  })
  return _form;
}

// 针对auctionVideo数据处理
 function formatAuctionVideosData(auctionVideos, item) {
  // 深拷贝 item 作为基础数据结构，并移除 component 属性
  const baseData = _.cloneDeep(item);
  delete baseData.component;
  delete baseData.properties;
  delete baseData.rules;
  // 清空 children 数组，准备填充视频数据
  baseData.children = (auctionVideos || []).map(video => {
    // 创建视频项的基础结构
    const videoItem = {
      id: null,
      name: null,
      label: null,
      dataId: null,
      defaultValue: null,
      valueDisplayName: null,
      type: "COMPLEX",
      valueType: null,
      rules: null,
      options: null,
      children: [],
      extendValue: null,
      properties: null,
      propType: null
    };

    // 使用 item.children 作为模板，填充实际数据
    videoItem.children = item.children.filter((item)=>item.name !== 'videoTips').map(childTemplate => {
     
      const childItem = _.cloneDeep(childTemplate);
      delete childItem.component;
      delete childItem.properties;
      delete childItem.rules;
      
      // 根据不同的 name 设置对应的值
      switch (childItem.name) {
        case 'videoType':
          childItem.defaultValue = video.videoType || "宝贝讲解";
          childItem.valueDisplayName = "";
          break;
          
        case 'videoId':
          childItem.defaultValue = video.videoId;
          if (video.videoInfoJson) {
            childItem.extendValue = {
              [video.videoId]: {
                videoInfoJson: JSON.stringify(video.videoInfoJson)
              }
            };
          }
          break;
      }

      return childItem;
    });

    return videoItem;
  });

  return baseData;
}
/**
 * 根据图片 URL 获取图片的宽高
 * 返回 Promise，resolve 一个包含 width/height 的对象
 * 注意：读取 naturalWidth/naturalHeight 不涉及跨域像素数据，通常不会触发 CORS 限制
 */
function getImageSizeByUrl(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    // 图片加载成功后读取天然尺寸（优先 naturalWidth/Height，兼容性回退到 width/height）
    img.onload = () => {
      resolve({
        url,
        width: img.naturalWidth || img.width,
        height: img.naturalHeight || img.height
      });
    };
    // 图片加载失败时返回错误，便于上层根据情况兜底
    img.onerror = (e) => {
      reject(e);
    };
    // 触发加载
    img.src = url;
  });
}
/**
 * 批量获取多个图片 URL 的宽高信息
 * 保证整体成功返回：单个失败时兜底为 { width: 0, height: 0 }
 */
export function getImagesSizes(urls = []) {
  const tasks = urls.map(url =>
    getImageSizeByUrl(url).catch(() => ({ width: 0, height: 0,url }))
  );
  return Promise.all(tasks);
}
// 处理有children的表单
function _getFormatedItem(item, form) {
  // 特殊处理的字段 开始
  if (item.name === 'sku') {
    // 规格信息需要沿用之前组件，特殊处理
    return;
  }
  
  let field = {
      name: item.name,
      type: item.type,
      valueDisplayName: item.valueDisplayName,
      label: item.label,
  }
  if (nendTransformMultiFields.includes(item.name) && form[item.name]?.length) {
    field = {
        name: item.name,
        children: form[item.name].map((val, i) => {
          return {
              name: `${item.name}_${i}`,
              defaultValue: val
          }
      })
    } 
    return field;
  }
  if (['wirelessDesc'].includes(item.name)) {
    let defaultValue = form[item.name]
    if(Array.isArray(defaultValue)){
      field.children = defaultValue
    }else{
      field.defaultValue = html2wapHtml(defaultValue)
    }
    return field;
  }

  if(["auctionVideos"].includes(item.name)){
    field = formatAuctionVideosData(form[item.name],item)
    return field;
  }
  // 对select 自定义值做转换处理
  if (form.selectCustoms && form.selectCustoms[item.name]) {
    if(form[item.name] instanceof Array) {
      field.extendValue = {}
      const defaultValue = form[item.name].map(val => {
        if(form.selectCustoms[item.name].includes(val)) {
          const customId = window._tb_cutomId-- + '' 
          field.extendValue[customId] = { inputValue : val }
          return customId
        } else {
          return val
        }
      })
      field.defaultValue = JSON.stringify(defaultValue)
      field.valueDisplayName = JSON.stringify(form[`${item.name}_displayName`])
      return field;
    } else {
      field.defaultValue = window._tb_cutomId-- + '' 
      field.extendValue = {
        [field.defaultValue]: { inputValue :form[item.name]}
      }
      field.valueDisplayName = form[item.name]
      return field;
    }
  }
  // 度量衡特殊处理组合
  const formats = form[`${item.name}_formats`]
  if(formats?.length) {
    const concatTypes = ['input', 'operator', 'unit'];
    const isEveryValue = formats.every(item => item.text)
    let value = '';
    // 度量衡组合完整才更新
    if(isEveryValue) {
      value = formats.filter(item => concatTypes.includes(item.type)).map(item => item.text).join('');
    }
    field.defaultValue = value
    return field;
  }
  // needShowMultiComplexFields是特殊的MULTICOMPLEX或者是必填的MULTICOMPLEX类型
  const isNeedShowMultiComplexField = item.type === 'MULTICOMPLEX' && (needShowMultiComplexFields.includes(item.name) || (item.rules && item.rules.find(i => i.required)))
  if (isNeedShowMultiComplexField) {
      field.children = (form[item.name] || []).map((cv, cvi) => {
          let cv_field = {
              name: `${item.name}_${cvi}`
          }
          let cv_children = []
          for(const cvk in cv) {
            cv[cvk] && cv_children.push(_formatValue({name: cvk}, cv[cvk]))
          }
          cv_field.children = cv_children
          return cv_field
      })
  } else if (item.children?.length) {
      let children = item.children.map(c => {
          return _getFormatedItem(c, form)
      }).filter(Boolean)
      if (children.length) {
          field.children = children
      } else {
          return false
      }
  } else {
      const value = form[item.name]
      const displayName = form[`${item.name}_displayName`]
      field = _formatValue(field, value, displayName)
  }
  return field
}

export function formatFormData(form, formSections) {
  let fieldDescriptorList = []
  formSections.forEach(section => {
    section.children.forEach(item => {
      fieldDescriptorList.push(_getFormatedItem(item, form))
    })
  })
  return fieldDescriptorList
}

// 合并动态属性的方法
export function merge_fieldDescriptorList(orifields = [], newfields = []) {
  let _ori = JSON.parse(JSON.stringify(orifields))
  let _new = newfields.filter(Boolean)
  _new.forEach(newfield => {
      let index = _ori.findIndex(ori => ori.name === newfield.name)
      if (index > -1) {
          _ori[index] = newfield
      } else {
        _ori.push(newfield)
      }
  })
  return _ori
}


